"use client";
import { jsx as e, Fragment as r } from "react/jsx-runtime";
import { createSvgIcon as t } from "@mui/material/utils";
const n = t(
  /* @__PURE__ */ e(r, { children: /* @__PURE__ */ e(
    "path",
    {
      d: "M7.49996 11.5L11.5 15.5C11.78 15.78 12.23 15.78 12.5 15.5L16.5 11.5C16.7 11.3 16.76 10.99 16.65 10.73C16.54 10.46 16.28 10.29 15.99 10.29H7.98996C7.69996 10.29 7.43996 10.46 7.32996 10.73C7.21996 10.99 7.27996 11.3 7.47996 11.5H7.49996Z",
      fill: "currentColor"
    }
  ) }),
  "KmxCaretDownFilled"
);
export {
  n as default
};
